(function () {
	"use strict";

	angular.module("sempraWebapp").component("operationAndServiceCountersRollover", {
		templateUrl:
			"app/facilityKarcherDetails/operationAndServiceCountersRollover/operationAndServiceCountersRollover.html",
		controller: operationAndServiceCountersRollover,
		bindings: {
			operationCountersList: "<",
			serviceCountersList: "<",
			defaultVisibilityState: "<"
		},
		controllerAs: "vm"
	});

	function operationAndServiceCountersRollover() {
		var vm = this;

		vm.$onInit = function () {
			vm.visibilityState = vm.defaultVisibilityState;
			vm.iconSource = !vm.visibilityState
				? 'expand_less'
				: 'expand_more';
		};

		vm.$onChanges = function () {};

		vm.hideContent = function () {
			vm.visibilityState = !vm.visibilityState;
			vm.iconSource = !vm.visibilityState
				? 'expand_less'
				: 'expand_more';
		};

		vm.convertToInt = function(data) {
			return parseInt(data);
		}
	}
})();
